"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../util/colors");
var NavLink = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"], ["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color || colors_1.colors.gray950;
}, function (_a) {
    var color = _a.color;
    return color || colors_1.colors.black;
});
exports.default = NavLink;
var templateObject_1;
//# sourceMappingURL=NavLink.js.map